import { useEffect } from 'react';

const useTriggerEffect = (trigger: () => void) => {
  useEffect(() => {
    trigger();
  }, [trigger]);
};

export default useTriggerEffect;
